import RowMenu from "../../../core/components/data-grid/RowMenu";
import {Menu} from "antd";
import {t} from "i18next";
import {useHistory} from "react-router-dom";
import {Pages} from "../../../AppRouter";
import {useModal} from "../../../core/context/ModalContext";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import UserHospital from "../UserHospitalEdit";
import UserCreateEdit from "../UserCreateEdit";
import {PERMISSIONS, useUser} from "../../../core/context/UserContext";

export default function UserRowMenu({row})
{
    const history = useHistory();
    const {openModal, closeModal} = useModal()
    const {refreshDataGrid} = useDataGrid()
    const {hasPermission} = useUser()

    return (
        <>
            <RowMenu text={row.id}>
                <Menu>
                    <Menu.Item
                        onClick={() => {
                            openModal(t('Edit User'), (
                                <UserCreateEdit
                                    userId={row.id}
                                    onSaved={() => { refreshDataGrid(); closeModal(); }}
                                />
                            ))
                        }}
                    >
                        {t('Edit')}
                    </Menu.Item>
                    <Menu.Item
                        onClick={() => {
                            openModal(t('User Hospitals'), (
                                <UserHospital userId={row.id}/>
                            ))
                        }}
                    >
                        {t('Edit Hospitals')}
                    </Menu.Item>
                    {
                        // "Çevrimiçi" kolonu kimin bağlı olduğunu söyler; ne yaptığı loglarda —
                        // grid userId ile önden filtreli açılır (çevrimiçi paneliyle aynı akış).
                        hasPermission(PERMISSIONS.LOG_MANAGEMENT) && (
                            <Menu.Item
                                onClick={() => {
                                    history.push(`${Pages.Log.DataGrid}?userId=${encodeURIComponent(row.id)}`)
                                }}
                            >
                                {t('Logs')}
                            </Menu.Item>
                        )
                    }
                </Menu>
            </RowMenu>
        </>
    )
}
